import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import ProductsTableComponent from './ProductsTableComponent'
import Paper from '@material-ui/core/Paper'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({
  rootPaper: {
    flexGrow: 1,
    borderRadius: 5,
    width: '100%',
    marginTop: theme.spacing.unit * 2,
    backgroundColor: theme.palette.grey['100']
  },
  topGrid: {
    paddingTop: '0 !important'
  },
  appBar: {
    borderRadius: 5
  },
  title: {
    lineHeight: '40px',
    flex: 1
  },
  itemPaper: {
    height: 40,
    borderRadius: 5
  },
  leftTypo: {
    paddingLeft: theme.spacing.unit
  },
  rightTypo: {
    paddingRight: theme.spacing.unit
  }
})
class SummaryComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    payments: PropTypes.array.isRequired,
    onSelectAllProducts: PropTypes.func.isRequired,
    onSelectProduct: PropTypes.func.isRequired,
    onUnselectProduct: PropTypes.func.isRequired
  }

  getPaidProducts = () => {
    const { payments } = this.props
    let paidProducts = []
    if (payments) {
      payments.map(p => {
        if (p.paidProducts) {
          paidProducts = [...paidProducts, ...p.paidProducts]
        }
        return null
      })
    }
    return paidProducts
  }
  renderTotalPool(classes, total) {
    return (
      <Grid item xs={11}>
        <Paper className={classes.itemPaper}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start">
            <Grid item>
              <Typography variant="subheading" className={classes.leftTypo}>
                Total billard :
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="subheading"
                className={classes.rightTypo}>{`${total} €`}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }
  renderTotalProducts(classes, total) {
    return (
      <Grid item xs={11}>
        <Paper className={classes.itemPaper}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start">
            <Grid item>
              <Typography variant="subheading" className={classes.leftTypo}>
                Total Consommations :
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="subheading"
                className={classes.rightTypo}>{`${total} €`}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }
  render() {
    const { classes, transaction } = this.props
    const { pool, products } = transaction
    let productsArray = []
    if (products) {
      productsArray = _.orderBy(
        Object.keys(products).map(key => ({ ...products[key], key: key })),
        ['createdAt'],
        ['asc']
      )
    }
    if (pool && pool.transfert && pool.transfert.total) {
      productsArray = [
        {
          key: '1',
          name: 'Transfert',
          price: pool.transfert.total,
          id_sale_product_detail: pool.transfert.id_sale_product_detail
        },
        ...productsArray
      ]
    }
    if (pool && pool.total) {
      productsArray = [
        {
          key: '0',
          name: 'Billard',
          price: pool.total,
          id_sale_product_detail: pool.id_sale_product_detail
        },
        ...productsArray
      ]
    }
    const paidPoducts = this.getPaidProducts()
    return (
      <Paper elevation={3} className={classes.rootPaper}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="center"
          spacing={16}>
          <Grid className={classes.topGrid} item xs={12}>
            <AppBar elevation={1} className={classes.appBar} position="static">
              <Toolbar>
                <Typography
                  variant="title"
                  className={classes.title}
                  color="inherit">
                  Total
                </Typography>
                <Typography variant="title" color="inherit">{`${Number(
                  transaction.total
                ).toFixed(2)} €`}</Typography>
              </Toolbar>
            </AppBar>
          </Grid>
          <Grid item xs={11}>
            <ProductsTableComponent
              products={productsArray}
              paidProducts={paidPoducts}
              payments={this.props.payments}
              onSelectProduct={this.props.onSelectProduct}
              onUnselectProduct={this.props.onUnselectProduct}
              onSelectAllProducts={this.props.onSelectAllProducts}
            />
          </Grid>
        </Grid>
      </Paper>
    )
  }
}

export default withStyles(styles)(SummaryComponent)



// WEBPACK FOOTER //
// ./src/components/payment/SummaryComponent.js